export function digitsConverter(number) {
  return number.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
    return d.charCodeAt(0) - 1632; // Convert Arabic numbers
  });
}

export function removeExtraZero(selectedCountryCode, mobileNumber) {
  if (
    (selectedCountryCode == '20' || selectedCountryCode == '962') &&
    mobileNumber.startsWith('0')
  ) {
    return mobileNumber.substring(1);
  }
  return mobileNumber;
}

export function getFormattedMsisdn(msisdn, countryCode) {
  let formattedMsisdn = msisdn;
  if (!formattedMsisdn) {
    return formattedMsisdn;
  }
  if (formattedMsisdn.startsWith('+')) {
    formattedMsisdn = formattedMsisdn.substring(1);
  }
  if (formattedMsisdn.startsWith(countryCode)) {
    formattedMsisdn = formattedMsisdn.replace(countryCode, '');
  }
  if (
    (countryCode == '20' || countryCode == '962') &&
    (formattedMsisdn.startsWith('0') || formattedMsisdn.startsWith('٠'))
  )
    formattedMsisdn = formattedMsisdn.substring(1);
  return formattedMsisdn;
}
